import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Logo = ({ imageUrl, logoClass }) => {
  return (
    <Link to={"/"} className="w-100 h-100">
      <img
        alt="store-logo"
        loading="lazy"
        className="p-1"
        src={imageUrl}
        style={{
          width: "110px",
          height: "100%",
          maxHeight: "80px",
        }}
      />
    </Link>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string,
};

export default Logo;
